'use strict';

import _ from 'lodash';

const CouponSchema = require('ck-core/source/schemas/CouponSchema');
const trialCtaPlans = require('ck-website/source/data/trialCtaPlans');

module.exports = _.memoize(
	async function(options) {
		options = options || {};

		if (options.planId && trialCtaPlans[options.planId]) {
			throw new Error('Coupons are not possible for trial plans');
		}

		let coupon;


		if (options.code) {
			const result = await CK.clientSockets.users.emit('verifyCoupon', options);

			coupon = new CouponSchema(result.coupon);
		}

		return {
			coupon
		};
	},
	function(options) {
		return JSON.stringify(options);
	}
);
